// extracted by mini-css-extract-plugin
export default {"modalDescription":"Primitives-ModalAccessibleDescription-module__modalDescription--U0Faa"};